import { render, staticRenderFns } from "./FeverDownload.vue?vue&type=template&id=3ef22934&scoped=true"
import script from "./FeverDownload.vue?vue&type=script&lang=js"
export * from "./FeverDownload.vue?vue&type=script&lang=js"
import style0 from "./FeverDownload.vue?vue&type=style&index=0&id=3ef22934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef22934",
  null
  
)

export default component.exports